
var OCS = OCS || {};
OCS.Viewer = OCS.Viewer || {};
OCS.Viewer.Classes = OCS.Viewer.Classes || {};
OCS.Viewer.Classes.LegendContainer = new Class({
    Implements: [Options, Events],
    options: {

    },
    element: null,
    legend_arrow: null,
    legend_content_container: null,
    legend_info: null,
    legend_tooltip: null,
    initialize: function (element, ops) {
        this.element = element;
        var current_obj = this.element.retrieve('legend_container');
        if (current_obj) {
            if (ops) {
                current_obj.setOptions(ops);
            }
            return current_obj;
        }
        this.setOptions(ops);

        this.legend_arrow = this.element.getElement('div.legend_arrow');
        this.legend_tooltip = this.element.getElement('div.legend_tooltip');
        this.legend_info = this.element.getElement('div.legend_info_container');
        this.legend_content_container = this.element.getElement('div.legend_content_container');
        this.element.store('legend_container', this);

    },
    position_readout: function (frac) {
        var target_dims = this.element.getCoordinates();
        var legend_tooltip_dims = this.legend_tooltip.getCoordinates();
        var legend_arrow_dims = this.legend_arrow.getCoordinates();

        var left = target_dims.width * frac;
        var legend_tooltip_width = legend_tooltip_dims.width,
                legend_tooltip_left = left - (legend_tooltip_width / 2);
        if(legend_tooltip_left < 0) {
            legend_tooltip_left = 0;
        }
        this.legend_tooltip.setStyles({
            left: legend_tooltip_left + "px"
        });

        this.legend_arrow.removeClass('hidden');
        var legend_arrow_width = legend_arrow_dims.width,
                legend_arrow_left = left - (legend_arrow_width / 2);
        if(legend_arrow_left < 0) {
            legend_arrow_left = 0;
        }        
        this.legend_arrow.setStyles({
            left: legend_arrow_left + "px"
        });
        return this;
    },
    hide: function () {
        this.element.addClass('hidden');
        this.hide_readout();
        return this;
    },
    hide_readout: function () {
        this.legend_tooltip.addClass('hidden');
        this.legend_arrow.addClass('hidden');
        return this;
    },
    show: function () {
        this.element.removeClass('hidden');
        return this;
    },
    show_readout: function () {
        this.legend_tooltip.removeClass('hidden');
        this.legend_arrow.removeClass('hidden');
        return this;
    },
    toggle: function () {
        if (this.element.hasClass('hidden')) {
            this.show();
        } else {
            this.hide();
        }
        return this;
    },
    update: function (tooltip_text, status, frac) {
        if (!tooltip_text) {
            this.hide_readout();
        } else {
            this.show_readout();
            this.position_readout(frac);
            this.legend_tooltip.set('text', tooltip_text);
        }
        if (status) {
            this.legend_info.set('html', status);
        }
    },

    destroy: function () {
        if (this.element) {
            this.element.removeEvents();
            this.element.store('legend_container', null);
            this.element = null;
        }
        if (this.legend_arrow) {
            this.legend_arrow = null;
        }
        if(this.legend_content_container) {
            this.legend_content_container = null;
        }
        if (this.legend_tooltip) {
            this.legend_tooltip = null;
        }
        if (this.legend_info) {
            this.legend_info = null;
        }
        this.removeEvents();
    }

});

